import React from 'react';

interface WorkflowCanvasSkeletonProps {
    className?: string;
}

const WorkflowCanvasSkeleton: React.FC<WorkflowCanvasSkeletonProps> = ({ className = '' }) => {
    return (
        <div className={`w-full h-full bg-gray-50 relative ${className}`}>
            {/* Top Left Panel Skeleton */}
            <div className="absolute top-4 left-4 z-10">
                <div className="bg-white rounded-lg shadow-md p-4 w-80">
                    <div className="space-y-4">
                        {/* Campaign Title */}
                        <div className="h-6 bg-gray-200 rounded animate-pulse w-3/4"></div>
                        {/* Campaign Description */}
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-full"></div>
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
                        {/* Stats */}
                        <div className="flex gap-4">
                            <div className="flex-1">
                                <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                                <div className="h-3 bg-gray-200 rounded animate-pulse mt-2 w-1/2"></div>
                            </div>
                            <div className="flex-1">
                                <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                                <div className="h-3 bg-gray-200 rounded animate-pulse mt-2 w-1/2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Top Right Panel Skeleton */}
            <div className="absolute top-4 right-4 z-10">
                <div className="bg-white rounded-lg shadow-md p-2 w-64">
                    <div className="space-y-3">
                        <div className="flex gap-2">
                            <div className="h-10 bg-gray-200 rounded animate-pulse flex-1"></div>
                            <div className="h-10 bg-gray-200 rounded animate-pulse flex-1"></div>
                            <div className="h-10 bg-gray-200 rounded animate-pulse flex-1"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side Panel Skeleton */}
            <div className="absolute top-20 right-4 z-10">
                <div className="bg-white rounded-lg shadow-md p-4 w-64">
                    <div className="space-y-4">
                        <div className="h-5 bg-gray-200 rounded animate-pulse w-1/2"></div>
                        <div className="space-y-3">
                            {Array.from({ length: 4 }).map((_, index) => (
                                <div key={index} className="h-12 bg-gray-200 rounded animate-pulse"></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Center Canvas Skeleton */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white rounded-lg shadow-md p-8 w-96">
                    <div className="space-y-6">
                        {/* Main Canvas Area */}
                        <div className="h-64 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
                            <div className="text-center">
                                <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse mx-auto mb-2"></div>
                                <div className="h-4 bg-gray-200 rounded animate-pulse w-32 mx-auto"></div>
                                <div className="h-3 bg-gray-200 rounded animate-pulse w-24 mx-auto mt-2"></div>
                            </div>
                        </div>

                        {/* Workflow Nodes Skeleton */}
                        <div className="space-y-4">
                            <div className="h-16 bg-gray-200 rounded-lg animate-pulse"></div>
                            <div className="h-16 bg-gray-200 rounded-lg animate-pulse"></div>
                            <div className="h-16 bg-gray-200 rounded-lg animate-pulse"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Center Panel Skeleton */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10">
                <div className="bg-white rounded-lg shadow-md p-3">
                    <div className="flex gap-2">
                        <div className="h-10 w-10 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-10 w-10 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-10 w-10 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
            </div>

            {/* Mini Controls Skeleton */}
            <div className="absolute bottom-4 right-4 z-10">
                <div className="bg-white rounded-lg shadow-md p-2">
                    <div className="space-y-2">
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkflowCanvasSkeleton;
